import React from "react"
import { ThemeProvider } from "styled-components"

import { useComponentizedPage } from "store/contexts/componentized-page"
import componentThemeExtension from "utils/componentThemeExtension"
import { getViewport } from "utils"

import TestimonialCard from "components/card/testimonial"
import TestimonialCelebrityCard from "components/card/testimonial/testimonial-celebrity-card"
import ContentfulTestimonialSlide from "./testimonial-slide"

const ContentfulTestimonialCard = ({ component, nested, elRef, onTop, standalone }) => {
  const {
    text,
    excerpt,
    attribution,
    attributionName,
    attributionTitle,
    attributionImage,
    rating,
    relatedClass,
    relatedProduct,
    id,
    hideOnPageLoad,
    shopifyProductVariant,
  } = component

  if ((attribution && attribution.image) || attributionImage) {
    return !nested && getViewport() !== "mobile" ? (
      <ContentfulTestimonialSlide elRef={elRef} component={component} />
    ) : (
      <ThemeProvider theme={componentThemeExtension(null, nested, onTop)}>
        <TestimonialCelebrityCard
          dataId={id}
          hideOnPageLoad={hideOnPageLoad}
          text={text.childMarkdownRemark.html}
          attribName={(attribution && attribution.name) || attributionName}
          attribTitle={(attribution && attribution.personTitle) || attributionTitle}
          image={
            (attributionImage && attributionImage[0].secure_url) ||
            (attribution && attribution.image && attribution.image[0]?.secure_url)
          }
          excerpt={excerpt && excerpt.childMarkdownRemark.html.replace(/^<p>(.*)<\/p>$/i, "$1")}
          standalone={!nested || standalone}
        />
      </ThemeProvider>
    )
  }

  const { classesOnPage } = useComponentizedPage()

  let product = null

  if (relatedClass) {
    const cls = classesOnPage.find((c) => c.classId === relatedClass.classId)
    if (cls) {
      product = {
        image: JSON.parse(cls.image),
        title: cls.title,
        subtitle: cls.instructorByline,
      }
    }
  }

  if (relatedProduct) {
    const shopifyProduct = shopifyProductVariant?.product
    product = {
      image:
        shopifyProductVariant?.media.length > 0 && shopifyProductVariant.media[0].image.originalSrc,
      title: shopifyProduct?.title,
    }
  }

  return (
    <TestimonialCard
      hideOnPageLoad={hideOnPageLoad}
      dataId={id}
      product={product}
      rating={rating}
      text={text.childMarkdownRemark.html}
      attribName={attribution ? attribution.name : attributionName}
      attribTitle={(attribution && attribution.personTitle) || attributionTitle}
    />
  )
}

export default ContentfulTestimonialCard
